import * as React from 'react'
import './index.scss'
import SportsSoccerIcon from '@mui/icons-material/SportsSoccer';
import {convertToTitleCase} from "../../utils";

export default function GameEvents({data: incidents}) {
    if (!incidents) {
        return ''
    }

    return incidents.map((i) => {
        if (i.incidentType === 'goal') {
            return <div className={'goal' + (i.isHome === '1' ? '' : ' away')}>
                <div className="minute">
                    {i.incidentClass === 'penalty' ?
                        <svg width="24" height="24" viewBox="0 0 24 24"
                             className="SvgWrapper fyGiev">
                            <path
                                d="M12 8.5c3.72 0 6.75 3.03 6.75 6.75S15.72 22 12 22s-6.75-3.03-6.75-6.75S8.28 8.5 12 8.5zm-.01 1.67c-1.29 0-2.47.5-3.37 1.3l.88.53-.64 2.39-1.94.69v.17c0 .65.13 1.26.35 1.83l.9-.46 1.5 1.67-.24 1.33a5.017 5.017 0 0 0 2.29.702l.276.008.198-.004a5.089 5.089 0 0 0 4.862-4.862l.004-.214c0-1.46-.62-2.77-1.61-3.7l-.84.78-2.62-1.11.28-1.04c-.1-.01-.19-.01-.28-.01zm2.42 3.95 1.34 2.46-2 2.2-2-.78v-2.91l2.66-.97zM22 2v9h-2V4H4v7H2V2h20z"
                                fill="var(--secondary-default)"
                            ></path>
                        </svg>
                        :
                        <SportsSoccerIcon/>
                    }
                    <div className="time">
                        {i.time}'
                        {i.addedTime && <span className="additional-time">+{i.addedTime}</span>}
                    </div>
                </div>
                <div className="score">{i.homeScore} - {i.awayScore}</div>
                <div className="player">
                    {
                        i.player &&
                        <div className="image" style={{
                            backgroundImage: `url(${i.player?.image})`
                        }}></div>
                    }

                    <div className="names-wrapper">
                        <div className="scorer">
                            {i.player ? i.player.shortName : i.playerName}
                        </div>
                        {
                            i.assist &&
                            <div className="assist">
                                {i.assist.shortName}
                            </div>
                        }
                    </div>
                </div>
            </div>
        }

        if (i.incidentType === 'card') {
            return <div className={'card' + (i.isHome === '1' ? '' : ' away')}>
                <div className="minute">
                    {
                        i.incidentClass === 'yellow' &&
                        <svg width="24" height="24" viewBox="0 0 16 16" className="SvgWrapper fyGiev yellow-card">
                            <path fill="var(--score-rating-s65)" d="M3 1h10v14H3z"></path>
                        </svg>
                    }
                    {
                        i.incidentClass === 'yellowRed' &&
                        <svg width="24" height="24" viewBox="0 0 24 24" className="SvgWrapper fyGiev">
                            <g>
                                <path d="M7 7v12h8v3H4V7h3z" fill="#ffcd00"></path>
                                <path fill="#c7361f" d="M9 2h11v15H9z"></path>
                            </g>
                        </svg>
                    }

                    {
                        i.incidentClass === 'red' &&
                        <svg
                            className="sr-momentum__event-icon  srt-fill-soccer-red-card"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 16 24"
                            style={{width: '24px', height: '24px'}}
                        >
                            <path
                                d="M2 0h12c1 0 2 1 2 2v20c0 1-1 2-2 2H2c-1 0-2-1-2-2V2c0-1 1-2 2-2z"></path>
                        </svg>
                    }

                    <div className="time">
                        {i.time}'
                        {i.addedTime && <span className="additional-time">+{i.addedTime}</span>}
                    </div>
                </div>
                <div className="player">
                    <div className="image" style={{
                        backgroundImage: `url(${i.player?.image})`
                    }}></div>
                    <div className="names-wrapper">
                        {
                            i.player ?
                                <div className="scorer">
                                    {i.player.shortName}
                                </div> :
                                <div className="scorer">
                                    {i.playerName}
                                </div>
                        }
                        {
                            i.reason && i.reason !== '-' &&
                            <div className="assist">
                                {i.reason}
                            </div>
                        }
                    </div>
                </div>
            </div>
        }

        if (i.incidentType === 'substitution') {
            return <div className={'substitution' + (i.isHome === '1' ? '' : ' away')}>
                <div className="minute">
                    <svg className="sr-momentum__event-icon" xmlns="http://www.w3.org/2000/svg" version="1.2"
                         viewBox="0 0 8 7">
                        <path className="srt-fill-soccer-substitution-in"
                              d="M4 2.16L2 0 0 2.16l.018.05H1.02V7h1.958V2.21H3.98" fill="#4fbe30"></path>
                        <path d="M8.02 4.837l-2 2.16-2-2.16.017-.05H5.04v-4.79h1.957v4.79H8"
                              className="srt-fill-soccer-substitution-out" fill="#e43b3b"></path>
                    </svg>
                    <div className="time">
                        {i.time}'
                        {i.addedTime && <span className="additional-time">+{i.addedTime}</span>}
                    </div>
                </div>
                <div className="player">
                    <div className="image" style={{
                        backgroundImage: `url(${i.playerIn?.image})`
                    }}></div>
                    <div className="names-wrapper">
                        {
                            i.playerIn &&
                            <div className="scorer">
                                In: {i.playerIn.shortName}
                            </div>
                        }
                        {
                            i.playerOut &&
                            <div className="assist">
                                Out: {i.playerOut.shortName}
                            </div>
                        }
                    </div>
                </div>
            </div>
        }

        if (i.incidentType === 'varDecision') {
            return <div className={'varDecision' + (i.isHome === '1' ? '' : ' away')}>
                <div className="minute">
                    <svg width="24" height="24" viewBox="0 0 24 24" className="SvgWrapper fyGiev">
                        <path
                            d="M22 4v14h-5v2H7v-2H2V4h20zM4.24 7.63h-1.1c-.07 0-.09.03-.07.09l2 6.56c.02.07.06.1.12.1h1.83c.06 0 .1-.04.12-.1l2.01-6.56c.02-.06-.01-.09-.07-.09H8c-.06 0-.1.03-.12.09l-1.63 5.56H6L4.36 7.72c-.02-.06-.06-.09-.12-.09zm8.6 0h-1.78c-.06 0-.1.03-.12.09l-2.12 6.56c-.01.07.01.1.07.1h1.07c.06 0 .1-.04.12-.1l.46-1.46h2.78l.46 1.46c.02.07.06.1.12.1h1.09c.07 0 .09-.04.07-.1l-2.1-6.56c-.02-.06-.06-.09-.12-.09zm5.84 0h-2.81c-.07 0-.1.03-.1.09v6.56c0 .07.04.1.1.1h1.03c.07 0 .1-.04.1-.1v-2.6h1.49l1.01 2.61c.02.06.06.09.13.09h1.08c.06 0 .09-.03.06-.09l-.01.01-1.09-2.77c.42-.21.73-.45.92-.73.23-.33.34-.74.34-1.22 0-.42-.1-.77-.29-1.06-.19-.29-.45-.51-.79-.66-.34-.15-.73-.23-1.17-.23zm-6.64 1.18.91 2.87h-2.06l.91-2.87h.24zm6.53-.04c.36 0 .63.07.82.21.2.14.29.34.29.61 0 .31-.08.54-.25.71-.17.17-.41.25-.72.25h-1.72V8.77z"
                            fill="var(--primary-default)"
                            ></path>
                    </svg>
                    <div className="time">
                        {i.time}'
                        {i.addedTime && <span className="additional-time">+{i.addedTime}</span>}
                    </div>
                </div>
                <div className="player">
                    <div className="image" style={{
                        backgroundImage: `url(${i.player?.image})`
                    }}></div>
                    <div className="names-wrapper">
                        <div className="scorer">
                            {
                                i.incidentClass === 'goalAwarded' && i.confirmed ? 'Penalty awarded' : 'Goal disallowed'
                            }
                        </div>
                        {
                            i.player &&
                            <div className="assist">
                                {i.player.shortName}
                            </div>
                        }
                    </div>
                </div>
            </div>
        }

        if (i.incidentType === 'inGamePenalty') {
            return <div className={'varDecision' + (i.isHome === '1' ? '' : ' away')}>
                <div className="minute">
                    {i.incidentClass === 'scored' ?
                        <svg width="24" height="24" viewBox="0 0 24 24"
                             className="SvgWrapper fyGiev scored">
                            <path
                                d="M12 8.5c3.72 0 6.75 3.03 6.75 6.75S15.72 22 12 22s-6.75-3.03-6.75-6.75S8.28 8.5 12 8.5zm-.01 1.67c-1.29 0-2.47.5-3.37 1.3l.88.53-.64 2.39-1.94.69v.17c0 .65.13 1.26.35 1.83l.9-.46 1.5 1.67-.24 1.33a5.017 5.017 0 0 0 2.29.702l.276.008.198-.004a5.089 5.089 0 0 0 4.862-4.862l.004-.214c0-1.46-.62-2.77-1.61-3.7l-.84.78-2.62-1.11.28-1.04c-.1-.01-.19-.01-.28-.01zm2.42 3.95 1.34 2.46-2 2.2-2-.78v-2.91l2.66-.97zM22 2v9h-2V4H4v7H2V2h20z"
                                fill="var(--secondary-default)"
                            ></path>
                        </svg>
                        :
                        <svg width="24" height="24" viewBox="0 0 24 24"
                             className="SvgWrapper fyGiev missed">
                            <path
                                d="M21 2H2v9h2V4h16v7h2V2h-1zm-5.09 9.34-3.92 3.93-3.88-3.88-1.41 1.42 3.87 3.87-3.9 3.91L8.09 22l3.9-3.9 3.9 3.9 1.41-1.41-3.9-3.91 3.93-3.92-1.42-1.42z"
                                fill="var(--error-default)"
                            ></path>
                        </svg>
                    }
                    <div className="time">
                        {i.time}'
                        {i.addedTime && <span className="additional-time">+{i.addedTime}</span>}
                    </div>
                </div>
                <div className="player">
                    <div className="image" style={{
                        backgroundImage: `url(${i.player?.image})`
                    }}></div>
                    <div className="names-wrapper">
                        {
                            i.player &&
                            <div className="scorer">
                                {i.player.shortName}
                            </div>
                        }
                        {
                            i.reason &&
                            <div className="assist">
                                {convertToTitleCase(i.reason)}
                            </div>
                        }
                    </div>
                </div>
            </div>
        }

        if (i.incidentType === 'period') {
            return <div className='period'>
                <div className="text">
                    <div className="name">
                        {i.text}
                    </div>
                    <div className="score">{i.homeScore} - {i.awayScore}</div>
                </div>
            </div>
        }
        if (i.incidentType === 'injuryTime') {
            return <div className='injuryTime'>
                <div className="text">
                    <div className="name">
                        Additional time {i.length}'
                    </div>
                </div>
            </div>
        }

        if (i.incidentType === 'penaltyShootout') {
            return <div className={'penaltyShootout' + (i.isHome === '1' ? '' : ' away')}>
                <div className="minute">
                    {i.incidentClass === 'scored' ?
                        <svg width="24" height="24" viewBox="0 0 24 24"
                             className="SvgWrapper fyGiev scored">
                            <path
                                d="M12 8.5c3.72 0 6.75 3.03 6.75 6.75S15.72 22 12 22s-6.75-3.03-6.75-6.75S8.28 8.5 12 8.5zm-.01 1.67c-1.29 0-2.47.5-3.37 1.3l.88.53-.64 2.39-1.94.69v.17c0 .65.13 1.26.35 1.83l.9-.46 1.5 1.67-.24 1.33a5.017 5.017 0 0 0 2.29.702l.276.008.198-.004a5.089 5.089 0 0 0 4.862-4.862l.004-.214c0-1.46-.62-2.77-1.61-3.7l-.84.78-2.62-1.11.28-1.04c-.1-.01-.19-.01-.28-.01zm2.42 3.95 1.34 2.46-2 2.2-2-.78v-2.91l2.66-.97zM22 2v9h-2V4H4v7H2V2h20z"
                                fill="var(--secondary-default)"
                            ></path>
                        </svg>
                        :
                        <svg width="24" height="24" viewBox="0 0 24 24"
                             className="SvgWrapper fyGiev missed">
                            <path
                                d="M21 2H2v9h2V4h16v7h2V2h-1zm-5.09 9.34-3.92 3.93-3.88-3.88-1.41 1.42 3.87 3.87-3.9 3.91L8.09 22l3.9-3.9 3.9 3.9 1.41-1.41-3.9-3.91 3.93-3.92-1.42-1.42z"
                                fill="var(--error-default)"
                            ></path>
                        </svg>
                    }
                    <div className="time">{i.time !== '-' ? i.time + "'" : "-"}</div>
                </div>
                <div className="score">{i.homeScore} - {i.awayScore}</div>
                <div className="player">
                    {
                        i.player &&
                        <div className="image" style={{
                            backgroundImage: `url(${i.player?.image})`
                        }}></div>
                    }

                    <div className="names-wrapper">
                        <div className="scorer">
                            {i.player ? i.player.shortName : i.playerName}
                        </div>
                        {
                            i.assist &&
                            <div className="assist">
                                {i.assist.shortName}
                            </div>
                        }
                    </div>
                </div>
            </div>
        }

        return i.incidentType + ' Not implemented'
    })
}
